import { apiCall, ApiConfig } from '../../config/api'
import { DataGridElements, WorkOrderState } from '../../interfaces'
import { getWorkOrderStatesAction } from '../actions/workOrderStateActions'
import { call, put, takeEvery } from '@redux-saga/core/effects'
import { AxiosError, AxiosResponse } from 'axios'
import { GET_WORKORDERSTATE } from '../types/workOrderStateActionsTypes'

export function* getWorkOrderStatesAsync() {
  try {
    const { status, data }: AxiosResponse<DataGridElements<WorkOrderState>> =
      yield call(apiCall, 'GET', `${ApiConfig.WorkOrderStateApi}?pageSize=100`)
    if (status === 200) {
      yield put(getWorkOrderStatesAction(data.items))
    }
  } catch (error) {
    const serverError = error as AxiosError<string>
    yield put(getWorkOrderStatesAction([], serverError.message))
  }
}

export function* watchGetWorkOrderStatesAsync() {
  yield takeEvery(GET_WORKORDERSTATE, getWorkOrderStatesAsync)
}
